import {TranslationObject, getNestedTranslation} from '@colonist/i18n'
import {EnumUtils} from '../utils/EnumUtils'
import * as leaderboardTypes from '@colonist/leaderboard-types'

/**
 * @deprecated Import RankedDivisionTypes from @colonist/leaderboard-types
 */
export import RankedDivisionTypes = leaderboardTypes.RankedDivisionTypes

export function getRankedDivisionText(rankedDivision: RankedDivisionTypes): TranslationObject {
    const rankedDivisionKey = EnumUtils.getEnumKey(rankedDivision, RankedDivisionTypes)
    return {key: `strings:leaderboardPage.rankedDivision.${rankedDivisionKey}`}
}

/**
 * @deprecated Import RankedSubDivisionTypes from @colonist/leaderboard-types
 */
export import RankedSubDivisionTypes = leaderboardTypes.RankedSubDivisionTypes

export function getRankedFullDivisionText(rankedDivision: RankedDivisionTypes, rankedSubDivision: RankedSubDivisionTypes): TranslationObject {
    const subDivisionName = rankedSubDivision == RankedSubDivisionTypes.None ? '' : RankedSubDivisionTypes[rankedSubDivision]
    return getNestedTranslation({key: 'strings:leaderboardPage.rankedFullDivision'}, {
        rankedDivision: getRankedDivisionText(rankedDivision),
        rankedSubDivision: {key: 'strings:colonistCommon.utils.#buffer', options: {value: subDivisionName}},
    })
}

export enum LeaderboardCategoryStringID {
    Global = 'Global',
    Continent = 'Continent',
    Country = 'Country',
    CountryRegion = 'Country_Region',
    Friends = 'Friends'
}
